// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1":"student","75":"admin-add-edit-quiz","622":"admin-quiz","821":"in-quiz","915":"student-quizes","921":"student-quiz"}[chunkId] + "." + {"1":"488f08e5","75":"167a761d","622":"28298a39","821":"6792532b","915":"45dbad68","921":"864992e9"}[chunkId] + ".css";
};